import { Box } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { ProductQualityInstructions } from "../../types"
import { renderCheckMarkIcon } from "../../utils"

import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface Props {
  productQualityInstructions: ProductQualityInstructions
  onEdit: () => void
}

export const AssociatedTestTemplateOperatorActionSection: FC<Props> = ({
  productQualityInstructions,
  onEdit: openDialog,
}) => {
  const { hasPermissions } = usePermissionManager()
  const isOperatorActionRequired = Boolean(productQualityInstructions.isOperatorActionRequired)

  return (
    <Paper variant='outlined' elevation={0} className='flex flex-col gap-y-6 border-gray-300 p-6'>
      <Box className='flex items-center justify-between gap-4'>
        <Typography className='font-normal text-gray-900' variant='body2'>
          {renderCheckMarkIcon(isOperatorActionRequired)} Operator Action Required
        </Typography>
        {hasPermissions([PermissionActionType.TEST_TEMPLATE_MAINTENANCE]) && (
          <IconButton onClick={openDialog}>
            <EditOutlined color='primary' />
          </IconButton>
        )}
      </Box>
      {productQualityInstructions.operatorActionDescription && (
        <Typography className='font-normal text-gray-900' variant='body2'>
          {productQualityInstructions.operatorActionDescription}
        </Typography>
      )}
    </Paper>
  )
}
